/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
import { Button } from './../Entities/GlobalEntities'
import {
    updateScore,
    getMyAddress,
} from "../../../web3/SFM-ScoreBoardContract_Utils";
import { updateTeamScore } from "../../../web3/SFM-TeamsUtils";
import { AddImageToScene, loadImage, loadAudio } from "./../modules/utiltes"
import { SoundManager } from "../ScenesHelpers/SoundManager"
const commonStyle = {
    fontFamily: "monospace",
    fontStyle: "bold",
    color: "#ffffff",
    align: "center",
}

export class SceneScores extends Phaser.Scene {
    constructor() {
        super({
            key: "SceneScores",
        });
    }

    init(data) {
        // Access the mode parameter passed from Scene 1
        this.mode = data.mode;
        this.isDead = data.isDead
        this.player = data.player
    }

    preload() {
        loadImage(this, "deepspacescore", "assets/img/game/Background-4.png")
       // loadImage(this, "sendscorestbtn", "assets/img/game/SendScores.png")
        loadAudio(this, "scores", "assets/img/game/scores.wav")
        loadAudio(this, "fuelout", "assets/img/game/fuelout.wav")
    }

    async create() {
        this.game.sound.pauseAll();
        this.bg = AddImageToScene(this, "deepspacescore");
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.W);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.S);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.A);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.D);
        if (this.isDead == true) {
            this.sfx = {
                scores: SoundManager.createAudio(this, "scores", 1, false)
            };
            this.sfx.scores.play();
        } else {
            this.sfx = {
                fuelout: SoundManager.createAudio(this, "fuelout", 1, false)
            };
            this.sfx.fuelout.play();
        }

        const div = document.createElement("div");
        const currentScore = this.player.getCurrentPlayerScore();
        const lasthigh = this.player.getPlayerHighScore();

        this.text = this.add.text(80, 450, "Sending your score ... ", {
            fontFamily: commonStyle.fontFamily,
            fontSize: 28,
            fontStyle: commonStyle.fontStyle,
            color: commonStyle.color,
            align: commonStyle.align,
            });

            // send score
            if (this.mode === "off") {
                // call update score in the individual leaderboard
                await updateScore(currentScore);
            } else if (this.mode === "on") {
                //call updateScore in teams contract
                await updateTeamScore(currentScore);
            }
            
            this.scene.start("SceneTopScores", { player: this.player, mode: this.mode });

        this.add.dom(
            100,
            this.game.config.height * 0.4,
            div,
            "background-color: transparent; width: 200px; height: 0; font: 30px Arial"
        );
        const name = document.getElementById("tag");


        this.address = this.add.text(this.game.config.width * 0.5, 128, " ", {
            fontFamily: commonStyle.fontFamily,
            fontSize: 36,
            fontStyle: commonStyle.fontStyle,
            color: commonStyle.color,
            align: commonStyle.align,
        });

        const address = await getMyAddress();

        this.address.setOrigin(0.5, -3);
        this.address.setText(
            `Player: ${address.substring(0, 4)}...${address.substring(
        address.length - 4
      )}`
        );

        this.score = this.add.text(this.game.config.width * 0.5, 128, " ", {
            fontFamily: commonStyle.fontFamily,
            fontSize: 36,
            fontStyle: commonStyle.fontStyle,
            color: commonStyle.color,
            align: commonStyle.align,
        });

        this.score.setOrigin(0.5, -5);
        this.score.setText(`SCORE: ${currentScore}`);
    }

    update() {
        if (this.isDead == true) {
            this.title = this.add.text(this.game.config.width * 0.5, 128, "GAME OVER", {
                fontFamily: commonStyle.fontFamily,
                fontSize: 48,
                fontStyle: commonStyle.fontStyle,
                color: commonStyle.color,
                align: commonStyle.align,
            });
        } else {
            this.title = this.add.text(
                this.game.config.width * 0.5,
                128,
                "Fuel is Over", {
                    fontFamily: commonStyle.fontFamily,
                    fontSize: 48,
                    fontStyle: commonStyle.fontStyle,
                    color: commonStyle.color,
                    align: commonStyle.align,
                }
            );
        }

        this.title.setOrigin(0.5);
    }
}